import { useState, useEffect } from "react"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getDestinationListing } from "../../Services/admin-service";
import DeleteDestination from "../Destination/DeleteDestination";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const CityList = () => {

    const [cityList, setCityList] = useState([])

    useEffect(() => {
        const payload = { type: "city" }
        loadData(payload);
        // loadData()
    }, [])

    const loadData = (type) => {
        getDestinationListing(type)
            .then((res) => {
                setCityList(res.data.list)
            })
            .catch((err) => {
                toast.error(err.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            })
    }

    const renderActions = (rowData) => {
        return (
            <div><DeleteDestination listVal={cityList} onClickDelete={setCityList} destId={rowData._id} /></div>
        )
    }

    return (
        <>
            <ToastContainer />
            <DataTable className="mt-4" value={cityList} tableStyle={{ width: '100%' }}>
                <Column field="locationName" header="Location Name"></Column>
                <Column field="city" header="City"></Column>
                <Column field="state" header="State"></Column>
                <Column header="Action" body={renderActions}></Column>
            </DataTable>
        </>
    )
}


export default CityList